export default __webpack_public_path__ + "static/media/empty-box.dbb55e4a.svg";